import { getUserInfo } from "./api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/auth",
    getUserInfo: "getUserInfo"
});

export const getAuthUserInfoAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getUserInfo}`,
    async(_, { rejectWithValue }) => {
        const response = await getUserInfo();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);
